<template>
    <CModal :title="dialogTitle" :show.sync="dialogVisible">
        <CForm slot="default">
            <CInput
                v-model="model.title"
                :horizontal="true"
                label="Название"
                placeholder="Название категории"
            />

            <CInput
                v-model="model.description"
                :horizontal="true"
                label="Описание"
                placeholder="Описание категории"
            />

            <CSelect
                :value.sync="model.parent_id"
                :horizontal="true"
                :options="categoriesList"
                label="Родительская категория"
                placeholder="Родительская категория (необязательно)"
            />

            <CInput
                v-model="model.external_id"
                :horizontal="true"
                label="Внешний ID"
                placeholder="Внешний ID (необязательно)"
            />

            <CInput
                v-model="model.cart_button_title"
                :horizontal="true"
                label="Кнопка «В корзину», текст"
                placeholder="Текст на кнопке (необязательно)"
            />

            <CInput
                v-model="model.cart_button_link"
                :horizontal="true"
                label="Кнопка «В корзину», ссылка"
                placeholder="Ссылка кнопки (необязательно)"
            />

            <div class="flex items-center mt-2">
                <div class="w-3/12 col-form-label">Изображение</div>
                <div class="w-9/12 col-form-label">
                    <CInputFile
                        ref="picture"
                        horizontal
                        @change="selectPicture" />
                    <CImg
                        v-if="model.picture"
                        :src="pictureUrl(model.picture)"
                        class="m2"
                        width="300" />
                </div>
            </div>

            <div class="flex items-center mt-2">
                <div class="w-3/12 col-form-label">Активен</div>
                <div class="w-9/12 col-form-label">
                    <CSwitch
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.enabled"
                    />
                </div>
            </div>
        </CForm>

        <div slot="footer">
            <CButton
                color="light"
                class="ml-3"
                @click="close">Отмена</CButton>

            <CButton
                color="primary"
                class="ml-3"
                @click="submit">{{
                    submitButtonTitle
                }}</CButton>
        </div>
    </CModal>
</template>

<script>
    export default {
        name: 'EntityCategoryUpsertDialog',

        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
            categories: {
                type: Array,
                default: () => ([]),
            }
        },

        data: () => ({
            dialogVisible: false,
            model: {
                enabled: true
            },
        }),

        computed: {
            dialogTitle() {
                return typeof this.entity.id === 'number'
                    ? 'Редатирование категории'
                    : 'Создание категории';
            },

            submitButtonTitle() {
                return typeof this.entity.id === 'number' ? 'Сохранить' : 'Создать';
            },
            categoriesList() {
                return [{ value: null, label: 'Без родительской категории' }, ...this.categories
                    .filter(category => category.id !== this.entity.id)
                    .map(category => ({ value: category.id, label: category.title }))];
            },
        },

        watch: {
            dialogVisible: function (v) {
                if (v) {
                    this.setModel(this.entity);
                }
            },
        },

        methods: {
            open() {
                this.dialogVisible = true;
                console.log(this.categories);
            },

            close() {
                this.dialogVisible = false;
            },

            setModel(source) {
                this.model = source;
            },

            async submit() {
                if (!this.model.title) {
                    this.$root.$emit('showError', 'Название категории не может быть пустым.');
                    return;
                }

                try {
                    const { ...payload } = this.model;
                    const code = this.$route.params.code;

                    payload.parent_id = payload.parent_id ? +payload.parent_id : null;

                    if (typeof payload.id === 'number') {
                        await this.axios.put(
                            `/entities/${code}/update-category/${payload.entity_id}`,
                            payload
                        );
                    } else {
                        await this.axios.post(
                            `/entities/${code}/create-category/${payload.entity_id}`,
                            payload
                        );
                    }

                    this.$emit('success');
                    this.close();
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка создания/редактирования категории. ' + err);
                }
            },

            async selectPicture(FileList) {
                // Загружаем картинку
                if (FileList[0]) {
                    let formData = new FormData();
                    formData.append('file', FileList[0]);
                    let { data } = await this.axios.post('/files/upload', formData);
                    if (data && data.filename) {
                        this.model.picture = data.filename;
                    }
                }
            },

            pictureUrl(picture) {
                if (this.model.picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + picture;
                } else {
                    return false;
                }
            },
        },
    };
</script>
